import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { InventoryRepositoryBase } from '@skylab-shared/business';
export { InventoryRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(InventoryRepositoryBase)
export class InventoryRepository {
    public constructor(
        weaver: Weaver,
        http: Http
    ) { }
}
